import React, { FC } from 'react';
import { useToast } from '@common/toast';
import Icon from '@common/assets';
import { ModalTypes } from '@components/mypage/common/modalsWrap';
import { usePositionHide } from '@repository/match';
import { JobApplicationProcess, JobApplicationProcessType } from '@domain/constant/jobApplicationProcessType';
import classnames from 'classnames/bind';
import styles from './applyBtn.module.scss';
const cx = classnames.bind(styles);

interface Props {
  statusType: JobApplicationProcessType;
  positionSn: number;
  isJobdaPosition: boolean;
  openModal: (modalState: ModalTypes) => void;
  terminatePosition?: boolean;
  refetch: () => void;
}

const ApplyBtn: FC<Props> = ({
  positionSn,
  statusType,
  isJobdaPosition,
  openModal,
  terminatePosition = false,
  refetch,
}) => {
  const Toast = useToast();

  // 지원서 숨기기
  const { mutate: fetchPositionHide } = usePositionHide(() =>
    //숨김 후 지원현황 api재호출
    refetch(),
  );

  //지원서 삭제
  const handleDelete = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    e.stopPropagation();
    openModal('RESUME_DELETE');
  };

  const handleCancleApplyJobdaPosition = () => {
    if (terminatePosition) {
      Toast({
        size: 'xlarge',
        type: 'error',
        iconType: 'info',
        content: <>전형이 진행 된 경우나 지원 마감 시에는 취소가 불가능합니다.</>,
      });
      return;
    }

    openModal('APPLY_CANCEL');
  };

  //지원 취소
  const handleCancelApply = async (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    e.stopPropagation();
    if (isJobdaPosition) handleCancleApplyJobdaPosition();
    else openModal('APPLY_CANCEL');
  };

  //포지션 숨기기
  const handlePositionHide = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    e.stopPropagation();
    fetchPositionHide(positionSn);
  };

  //전형 종료로 이동
  const handlePositionEnd = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    e.stopPropagation();
    openModal('RESUME_END');
  };

  const getType = () => {
    switch (statusType) {
      case JobApplicationProcess.APPLY:
        return ['cancle', 'hide'];
      case JobApplicationProcess.INTERVIEW_OFFERED:
      case JobApplicationProcess.INTERVIEW_ACCEPTED:
      case JobApplicationProcess.INTERVIEW_DENIED:
      case JobApplicationProcess.INTERVIEW_ADJUSTED:
      case JobApplicationProcess.ACC_REQUEST:
      case JobApplicationProcess.ACC_SUBMIT:
      case JobApplicationProcess.PHS_REQUEST:
      case JobApplicationProcess.PHS_SUBMIT:
      case JobApplicationProcess.IN_PROGRESS:
        return isJobdaPosition ? ['hide'] : ['hide', 'end'];
      default:
        return ['hide'];
    }
  };

  //props로 들어온 type순서에 따라 보여주기 위해 map사용.
  const getBtnTypeEl = () =>
    getType().map((el) => {
      if (el === 'delete')
        return (
          <a className={cx('btn')} role="button" onClick={handleDelete}>
            지원서 삭제
          </a>
        );
      else if (el === 'cancle')
        return (
          <a className={cx('btn')} role="button" onClick={handleCancelApply}>
            지원 취소
          </a>
        );
      else if (el === 'hide')
        return (
          <a className={cx('btn')} role="button" onClick={handlePositionHide}>
            포지션 숨기기
          </a>
        );
      else
        return (
          <a className={cx('btn')} role="button" onClick={handlePositionEnd}>
            전형 종료로 이동
          </a>
        );
    });

  return (
    <div className={cx('applyBtnWrap')}>
      <a className={cx('applyBtn')} role="button">
        <Icon name="moreHorizonLight" width={32} height={32} />
        <span className={cx('hidden')}>{`resume ${statusType} btn`}</span>
      </a>
      <div className={cx('btnArea')}>{getBtnTypeEl()}</div>
    </div>
  );
};

export default ApplyBtn;
